/* ============================================================
   STUDIO FINEA — Theme Interactions
   Vanilla JS, keine Abhängigkeiten. Progressive Enhancement.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* -- 1. Sticky Header: verstecken beim Runterscrollen ------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var lastY = window.pageYOffset;
    var ticking = false;

    function update() {
      var y = window.pageYOffset;
      header.setAttribute('data-scrolled', y > 8 ? 'true' : 'false');
      // Nur verstecken, wenn deutlich nach unten und über der Fold
      if (y > lastY && y > 240) {
        header.setAttribute('data-hidden', 'true');
      } else {
        header.setAttribute('data-hidden', 'false');
      }
      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  /* -- 2. Scroll Reveal via IntersectionObserver ------------- */
  function initReveal() {
    var els = [].slice.call(document.querySelectorAll('[data-reveal]'));
    if (!els.length) return;
    if (reduceMotion) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }

    var ticking = false;
    function reveal() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      els = els.filter(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.92 && r.bottom > -40) { el.classList.add('is-in'); return false; }
        return true;
      });
      ticking = false;
      if (!els.length) window.removeEventListener('scroll', onScroll);
    }
    function onScroll() { if (!ticking) { window.requestAnimationFrame(reveal); ticking = true; } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', reveal);
    // Sofort + Sicherheits-Durchläufe (nach Preloader/Layout)
    reveal();
    setTimeout(reveal, 450);
    setTimeout(reveal, 1900);
  }

  /* -- 3. Mobile Nav Toggle ---------------------------------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.querySelector('[data-nav-drawer]');
    if (!toggle || !drawer) return;
    toggle.addEventListener('click', function () {
      var open = drawer.hasAttribute('data-open');
      if (open) { drawer.removeAttribute('data-open'); toggle.setAttribute('aria-expanded', 'false'); }
      else { drawer.setAttribute('data-open', ''); toggle.setAttribute('aria-expanded', 'true'); }
    });
  }

  /* -- 4. Produkt-Konfigurator (Format + Rahmen) ------------- */
  function initConfigurator() {
    var root = document.querySelector('[data-configurator]');
    if (!root) return;

    var variantData = root.querySelector('[data-variant-json]');
    var variants = [];
    try { variants = JSON.parse(variantData.textContent); } catch (e) { return; }

    var priceEl = root.querySelector('[data-config-price]');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add]');
    var availabilityEl = root.querySelector('[data-availability]');
    var groups = root.querySelectorAll('[data-option-group]');

    function currentSelection() {
      var opts = [];
      groups.forEach(function (g) {
        var sel = g.querySelector('[aria-pressed="true"]');
        opts.push(sel ? sel.getAttribute('data-value') : null);
      });
      return opts;
    }

    function money(cents) {
      var value = (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      return '€' + value;
    }

    function match() {
      var sel = currentSelection();
      return variants.find(function (v) {
        return v.options.every(function (o, i) {
          return sel[i] == null || o === sel[i];
        });
      });
    }

    /* Welche Werte einer Gruppe es mit der übrigen Auswahl überhaupt gibt.
       GEBRAUCHT SEIT DEM 01.10.2026, vorher fehlte das: Nicht jedes Format
       gibt es in jeder Ausführung. 21 × 28 hat keinen Schattenfugenrahmen,
       der Knopf dafür war aber anklickbar wie jeder andere. */
    function moeglich(gruppeIndex, wert) {
      var sel = currentSelection();
      return variants.some(function (v) {
        return v.options.every(function (o, i) {
          if (i === gruppeIndex) return o === wert;
          return sel[i] == null || o === sel[i];
        });
      });
    }

    function knoepfeMarkieren() {
      groups.forEach(function (g, gi) {
        g.querySelectorAll('[data-value]').forEach(function (b) {
          var geht = moeglich(gi, b.getAttribute('data-value'));
          b.classList.toggle('opt--aus', !geht);
          b.setAttribute('aria-disabled', geht ? 'false' : 'true');
          b.title = geht ? '' : 'In diesem Format nicht erhältlich';
        });
      });
    }

    function render() {
      knoepfeMarkieren();
      var v = match();
      if (!v) {
        /* DER FEHLER, DER HIER LAG: Bis zum 01.10.2026 stand an dieser
           Stelle »if (!v) return;«. Wählte jemand eine Kombination, die es
           nicht gibt, brach die Funktion still ab. Der Knopf sah ausgewählt
           aus, Preis und versteckte Variantennummer zeigten aber weiter die
           VORHERIGE Variante, und »In den Warenkorb« legte diese in den
           Korb. Also das falsche Produkt, ohne jede Warnung. */
        addBtn.setAttribute('disabled', '');
        addBtn.textContent = 'Diese Kombination gibt es nicht';
        /* Auch der Preis muss weg. Bleibt er stehen, liest man ihn als den
           Preis der gewählten Kombination, und die gibt es ja gerade nicht. */
        priceEl.textContent = '—';
        if (availabilityEl) {
          availabilityEl.textContent =
            'Dieses Format gibt es nicht in der gewählten Ausführung. '
            + 'Bitte eine andere wählen.';
        }
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = money(v.price);
      if (v.available) {
        addBtn.removeAttribute('disabled');
        addBtn.textContent = addBtn.getAttribute('data-label') || 'In den Warenkorb';
        if (availabilityEl) availabilityEl.textContent = '';
      } else {
        addBtn.setAttribute('disabled', '');
        addBtn.textContent = 'Edition geschlossen';
      }
    }

    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-value]');
        if (!btn) return;
        g.querySelectorAll('[data-value]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        render();
      });
    });

    render();
  }

  /* -- 5. Editorial Zoom (Klick auf großes Produktbild) ------ */
  function initZoom() {
    var triggers = document.querySelectorAll('[data-zoom]');
    if (!triggers.length) return;
    var overlay = document.createElement('div');
    overlay.className = 'zoom-overlay';
    overlay.setAttribute('hidden', '');
    overlay.innerHTML = '<img alt="">';
    document.body.appendChild(overlay);
    var img = overlay.querySelector('img');

    function open(src, alt) {
      img.src = src; img.alt = alt || '';
      overlay.removeAttribute('hidden');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      overlay.setAttribute('hidden', '');
      document.documentElement.style.overflow = '';
    }
    triggers.forEach(function (t) {
      t.addEventListener('click', function () {
        open(t.getAttribute('data-zoom-src') || t.currentSrc || t.src, t.alt);
      });
    });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* -- 6. Editions-Zähler: Count-up beim Sichtbarwerden ------- */
  function initCountup() {
    var els = document.querySelectorAll('[data-countup]');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var target = parseInt(el.getAttribute('data-countup'), 10);
        if (isNaN(target)) return;
        var start = null;
        var dur = 800;
        function tick(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          // ease-out
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(eased * target);
          if (p < 1) window.requestAnimationFrame(tick);
        }
        window.requestAnimationFrame(tick);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* -- 7. PDP: mobile Sticky-Add-to-Cart-Leiste --------------- */
  function initStickyBar() {
    var config = document.querySelector('[data-configurator]');
    if (!config) return;
    var addBtn = config.querySelector('[data-add]');
    var priceEl = config.querySelector('[data-config-price]');
    var form = config.querySelector('[data-config-form]');
    if (!addBtn || !form) return;

    var bar = document.createElement('div');
    bar.className = 'pdp-bar';
    bar.innerHTML = '<span class="pdp-bar__price"></span>' +
                    '<button type="button" class="btn pdp-bar__btn">In den Warenkorb</button>';
    document.body.appendChild(bar);
    var barPrice = bar.querySelector('.pdp-bar__price');
    var barBtn = bar.querySelector('.pdp-bar__btn');

    function sync() {
      barPrice.textContent = priceEl ? priceEl.textContent : '';
      if (addBtn.hasAttribute('disabled')) {
        barBtn.setAttribute('disabled', '');
        barBtn.textContent = addBtn.textContent;
      } else {
        barBtn.removeAttribute('disabled');
        barBtn.textContent = 'In den Warenkorb';
      }
    }
    barBtn.addEventListener('click', function () {
      sync();
      if (!barBtn.hasAttribute('disabled')) form.requestSubmit ? form.requestSubmit() : form.submit();
    });

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      var past = entries[0].boundingClientRect.top < 0;
      if (!visible && past) { sync(); bar.setAttribute('data-show', ''); }
      else { bar.removeAttribute('data-show'); }
    }, { threshold: 0 });
    io.observe(addBtn);
  }

  /* -- 8. Preloader: die Leinwand zeichnet sich --------------- */
  function initPreloader() {
    var pre = document.querySelector('[data-preloader]');
    if (!pre) return;
    if (reduceMotion) { pre.remove(); return; }
    /* Die Zeichnung selbst läuft im CSS. Hier wird nur noch abgeräumt.
       Die Klasse preloader--kurz setzt das Inline-Skript im Layout, bevor
       gezeichnet wird, sonst würde die Animation mitten im Lauf umspringen. */
    var kurz = pre.classList.contains('preloader--kurz');
    var dauer = kurz ? 800 : 1550;
    document.documentElement.classList.add('is-preloading');
    setTimeout(function () {
      pre.classList.add('preloader--done');
      document.documentElement.classList.remove('is-preloading');
    }, dauer);
    setTimeout(function () { pre.remove(); }, dauer + 650);
  }

  /* -- 9. Horizontaler Serien-Scroller (Scrollytelling) ------- */
  function initHScroll() {
    var sections = document.querySelectorAll('[data-hscroll]');
    if (!sections.length) return;
    // Basis-CSS ist nativ (normales horizontales Wischen) — Pin-Effekt nur Desktop + Motion.
    if (reduceMotion || window.matchMedia('(max-width: 899px)').matches) return;
    sections.forEach(function (sec) {
      var track = sec.querySelector('[data-hscroll-track]');
      if (!track) return;
      sec.classList.add('hscroll--pinned');
      var ticking = false;
      function update() {
        var rect = sec.getBoundingClientRect();
        var total = rect.height - window.innerHeight;
        if (total <= 0) { ticking = false; return; }
        var p = Math.min(Math.max(-rect.top / total, 0), 1);
        var max = track.scrollWidth - sec.clientWidth + 48;
        track.style.transform = 'translate3d(' + (-p * max) + 'px, 0, 0)';
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* -- 10. Produktbild-Lupe (Desktop, pointer: fine) ---------- */
  function initLoupe() {
    var main = document.querySelector('.pdp__main[data-zoom]');
    if (!main) return;
    var src = main.getAttribute('data-zoom-src');
    if (!src) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;
    var lens = document.createElement('div');
    lens.className = 'loupe';
    lens.style.backgroundImage = 'url("' + src + '")';
    main.appendChild(lens);
    main.addEventListener('mousemove', function (e) {
      var r = main.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width;
      var y = (e.clientY - r.top) / r.height;
      lens.style.left = (x * 100) + '%';
      lens.style.top = (y * 100) + '%';
      lens.style.backgroundPosition = (x * 100) + '% ' + (y * 100) + '%';
    });
    main.addEventListener('mouseenter', function () { lens.style.opacity = '1'; });
    main.addEventListener('mouseleave', function () { lens.style.opacity = '0'; });
  }

  /* -- 11. Hero-Parallax (Tiefe beim Scrollen) ----------------- */
  function initParallax() {
    if (reduceMotion) return;
    var media = document.querySelector('.hero__media');
    if (!media) return;
    var ticking = false;
    function update() {
      var y = window.pageYOffset;
      if (y < window.innerHeight * 1.2) {
        media.style.transform = 'translate3d(0,' + (y * 0.14) + 'px,0)';
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* -- 11. Vorschaubilder wechseln das große Bild -------------
     Die Vorschaubilder waren reine Deko: vier Bilder, auf die man klicken
     konnte, ohne dass etwas passierte. Auf der wichtigsten Seite des Shops. */
  function initThumbs() {
    var thumbs = document.querySelectorAll('[data-thumb]');
    if (!thumbs.length) return;
    var main = document.querySelector('.pdp__main');
    if (!main) return;
    var img = main.querySelector('img');
    if (!img) return;

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (!src) return;
        img.removeAttribute('srcset');   // sonst gewinnt das alte Bilderset
        img.removeAttribute('sizes');
        img.src = src;
        main.setAttribute('data-zoom-src', t.getAttribute('data-zoom-src') || src);
        var lens = main.querySelector('.loupe');
        if (lens) lens.style.backgroundImage = 'url("' + main.getAttribute('data-zoom-src') + '")';
        // Vermerk unter erzeugten Räumen (07.10.2026): sichtbar, solange
        // das große Bild einen Raum zeigt, sonst nicht.
        var vermerk = document.querySelector('[data-vermerk]');
        if (vermerk) vermerk.hidden = !t.hasAttribute('data-raum');
        thumbs.forEach(function (o) {
          o.setAttribute('aria-pressed', o === t ? 'true' : 'false');
        });
      });
    });
  }

  /* -- Init ---------------------------------------------------- */
  function boot() {
    initPreloader();
    initHeader();
    initReveal();
    initMobileNav();
    initConfigurator();
    initZoom();
    initCountup();
    initStickyBar();
    initHScroll();
    initLoupe();
    initThumbs();
    initParallax();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();

/* Cookie-Einstellungen im Fuß (13.10.2026, wie in der Vorbesichtigung): öffnet Shopifys eigenen
   Banner erneut. Sichtbar erst, wenn Shopifys Skript da ist, damit der Knopf nie ins Leere führt. */
(function () {
  var knopf = document.querySelector('[data-cookie-einstellungen]');
  if (!knopf) return;
  var bereit = function () {
    return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
  };
  var zeigen = function () { if (bereit()) knopf.hidden = false; };
  knopf.addEventListener('click', function () { if (bereit()) window.privacyBanner.showPreferences(); });
  zeigen();
  window.addEventListener('load', zeigen);
  setTimeout(zeigen, 2500);
})();
